import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

const styles = makeStyles(theme => ({
  defaultBlueButton: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.primary.light,
    margin: theme.spacing(3, 0, 2, 0),
  },
  firstLine: {
    color: `#525E6D`,
    textDecoration: `underline solid #525E6D`,
    fontSize: theme.fontSize[2],
    paddingBottom: theme.spacing(4),
    textAlign: `left`,
    width: `100%`,
  },
  label: {
    color: `#525E6D`,
    fontSize: theme.fontSize[0],
    paddingBottom: theme.spacing(1),
    textAlign: `left`,
    width: `100%`,
  },
  subMessage: {
    color: `black`,
    fontSize: theme.fontSize[1],
    paddingBottom: theme.spacing(3),
    textAlign: `left`,
    width: `100%`,
    borderBottom: `1px solid #7F8FA4`,
  },
}))

export default function ShowMessage({
  buttons = null,
  firstLine = null,
  subMessageLabel = `Mensaje`,
  subMessage = null,
  onChange,
  id,
}) {
  const classes = styles()

  function handleOnClick(accepted = false) {
    return () => {
      onChange({
        accepted,
        id,
      })
    }
  }

  return (
    <Grid container justify="center" alignContent="flex-start" alignItems="flex-start">
      {firstLine && <Typography className={classes.firstLine}>{firstLine}</Typography>}
      {subMessage && (
        <Grid container>
          <Typography className={classes.label}>{subMessageLabel}</Typography>
          <Typography className={classes.subMessage}>{subMessage}</Typography>
        </Grid>
      )}
      {buttons && (
        <Grid container justify="center" className={classes.buttonContainer}>
          {buttons.cancel && (
            <Button
              variant="contained"
              color="secondary"
              className={buttons.cancel.class !== `default` ? classes[buttons.cancel.class] : ``}
              onClick={handleOnClick()}
            >
              {buttons.cancel.text}
            </Button>
          )}
          {buttons.accept && (
            <Button
              variant="contained"
              color="secondary"
              className={buttons.accept.class !== `default` ? classes[buttons.accept.class] : ``}
              onClick={handleOnClick(true)}
            >
              {buttons.accept.text}
            </Button>
          )}
        </Grid>
      )}
    </Grid>
  )
}
